<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
<div  v-if="order && !loading">

 

  <b-row>
    <div class="mb-1" v-if="!$route.params.token">
      <b-button class="back-button" @click="goBackToOrders">
        <img src="@/assets/images/arrow.svg" width="10" />
        
      </b-button>
    </div>
    <b-card class="mb-1 col-md-12" :title="'Order #'+order.id">
      <div class="order-status">
        <template v-if="(user && user.is_special_user==true) || $isFactory">
            <b-badge v-if="order.status=='dispatched'" variant="success">Dispatched</b-badge>
            <b-badge v-else-if="order.status=='shipped'" variant="success">Shipped</b-badge>
            <b-badge v-else-if="order.status=='scanned'" variant="success">Scans effectués</b-badge>
            <b-badge v-else-if="order.status=='delivered'" variant="success">Delivered</b-badge>
            <b-badge v-else-if="order.status=='confirmed'" variant="success">Confirmed</b-badge>
            <b-badge v-else-if="order.status=='in production'" variant="success">In production</b-badge>
            <b-badge v-else-if="order.status=='verified'" variant="success">Verified</b-badge>
            <b-badge v-else-if="order.status=='validated'" variant="success">Validated</b-badge>
            <b-badge v-else-if="order.status=='printing'" variant="success">Printing</b-badge>
            <b-badge v-else-if="order.status=='ready_to_print'" variant="success">Ready to print</b-badge>
            <b-badge v-else-if="order.status=='completed'" variant="info">Received</b-badge>
            <b-badge v-else-if="order.status=='failed'" variant="danger">Failed</b-badge>
            <b-badge v-else-if="order.status=='canceled'" variant="danger">Canceled</b-badge>
            <b-badge v-else-if="order.status=='returned'" variant="danger">Returned</b-badge>
          </template>
          <template v-else>
              <b-badge v-if="order.status=='dispatched'" variant="success">Dispatched</b-badge>
            <b-badge v-else-if="order.status=='scanned'" variant="success">Scans effectués</b-badge>
            <b-badge v-else-if="order.status=='delivered'" variant="success">Delivered</b-badge>
            <b-badge v-else-if="order.status=='verified'" variant="success">Verified</b-badge>
            <b-badge v-else-if="order.status=='validated'" variant="success">Validated</b-badge>
            <b-badge v-else-if="order.status=='printing'" variant="success">Printing</b-badge>
            <b-badge v-else-if="order.status=='completed'" variant="info">Completed</b-badge>
            <b-badge v-else-if="order.status=='ready_to_print'" variant="success">Ready to print</b-badge>
            <b-badge v-else-if="order.status=='failed'" variant="danger">Failed</b-badge>
            <b-badge v-else-if="order.status=='canceled'" variant="danger">Canceled</b-badge>
            <b-badge v-else-if="order.status=='returned'" variant="danger">Returned</b-badge>
            <b-badge v-else variant="danger">error</b-badge>
           
          </template>
      </div>
      <div class="order-infos">
        <div class="order-info">
          <div class="legend">Date</div>
          <div class="value">{{order.date}}</div>
        </div>
        <div class="order-info">
          <div class="legend">Total</div>
          <div class="value">{{order.amount}}€</div>
        </div>
        <div class="order-info">
          <div class="legend">Items</div>
          <div class="value">x{{calculateOrderItems()}}</div>
        </div>
      </div>



      <OrderItemsContent v-if="cart_items" :fitting_result_custom_fit="fitting_result_custom_fit" :order="order" :cart_items="cart_items" :photos="photos" :eyeToLensDistance="eyeToLensDistance" :pupillaryHeight="pupillaryHeight" :user="user" :fitting_results="fitting_results" />
 
      
    
      <b-row class="totals">
        <span>{{ order.order_items.length }} item(s)</span>

        <template v-if="!user || user.hide_prices!=true">
                    <span v-if="order.promotion!=null">{{order.amount - ((order.amount/100)*order.promotion.amount).toFixed(2)}}€</span>
                    <span v-else>{{order.amount}}€</span>
                  </template>
                  <template v-else><span>On demand</span></template>
      
      </b-row>
      
     
      <b-card class="border">
        <div class="header-card">
          <div class="title-card">
            <img src="@/assets/images/delivery.svg" />
            <span>Order tracking</span>
          </div>
          <!--<b-button variant="primary">Track order</b-button>-->
        </div>
        <br /><br />
        <b-row class="status-content">
          <div class="status-item">
            <img v-if="order.status=='completed' || order.status=='in production' || order.status=='returned' || order.status=='confirmed' || order.status=='shipped' || order.status=='validated' || order.status=='ready_to_print' || order.status=='verified'  || order.status=='printing' || order.status=='printed'  || order.status=='dispatched' || order.status=='delivered'" src="@/assets/images/valid.svg" />
            <img v-else src="@/assets/images/unvalid.svg" />
            <span v-if="(user && user.is_special_user==true) || $isFactory">Received</span>
            <span v-else>Completed</span>
          </div>
          <div class="status-separator"></div>

          <template v-if="(user && user.is_special_user==true) || $isFactory">
            <div class="status-item">
            <img v-if="order.status=='printing'|| order.status=='shipped' || order.status=='in production' || order.status=='returned' || order.status=='confirmed' || order.status=='validated' || order.status=='verified' || order.status=='printed'  || order.status=='dispatched' || order.status=='delivered'" src="@/assets/images/valid.svg" />
            <img v-else src="@/assets/images/unvalid.svg" />
            <span>Confirmed</span>
          </div>
          <div class="status-separator"></div>
          </template>
          <template v-if="(user && user.is_special_user==true) || $isFactory">
            <div class="status-item">
              <img v-if="order.status=='printing'|| order.status=='shipped' || order.status=='in production' || order.status=='returned' || order.status=='verified' || order.status=='printed'  || order.status=='dispatched' || order.status=='delivered'" src="@/assets/images/valid.svg" />
            <img v-else src="@/assets/images/unvalid.svg" />
            <span>In production</span>
          </div>
          <div class="status-separator"></div>
          </template>
          <template v-else>
          <div class="status-item">
            <img v-if="order.status=='printing' || order.status=='shipped' || order.status=='verified' || order.status=='returned' || order.status=='printed'  || order.status=='dispatched' || order.status=='delivered'" src="@/assets/images/valid.svg" />
            <img v-else src="@/assets/images/unvalid.svg" />
            <span>Printing</span>
          </div>
          <div class="status-separator"></div>
        </template>
          <div class="status-item">
            <img v-if="order.status=='printed' || order.status=='shipped' || order.status=='verified'  || order.status=='dispatched' || order.status=='returned' || order.status=='delivered'" src="@/assets/images/valid.svg" />
            <img v-else src="@/assets/images/unvalid.svg" />
            <span v-if="(user && user.is_special_user==true) || $isFactory">Verified</span>
            <span v-else>Printed</span>
          </div>
          <div class="status-separator"></div>
          <div class="status-item">
            <img v-if="order.status=='dispatched' || order.status=='shipped' || order.status=='delivered' || order.status=='returned'" src="@/assets/images/valid.svg" />
            <img v-else src="@/assets/images/unvalid.svg" />
            <span>Shipped</span>
          </div>
          <div class="status-separator"></div>
          <div class="status-item">
            <img v-if="order.status=='delivered' || order.status=='returned'" src="@/assets/images/valid.svg" />
            <img v-else src="@/assets/images/unvalid.svg" />
            <span>Delivered</span>
          </div>
        </b-row>
      </b-card>

      <b-card v-if="(user && user.is_special_user==true) || $isFactory"  class="border">
        <div class="header-card">
          <div class="title-card">
            <img class="black" src="@/assets/images/doc.svg" />
            <span>Note</span>
          </div>
          <!--<b-button variant="primary">Track order</b-button>-->
        </div>
          <br />

        <div class="note-form">
          <b-form-group 
                      
              label-for="basicInput"
            >
              <b-form-textarea
                required
                id="basicInput"
                v-model="order.note"
                placeholder="Note"
                rows="1"
                max-rows="10"
              />
            
          </b-form-group>
          </div>
          <div class="note-form-button">
          <label>Photo:</label>
          <b-form-group
            
            >
          
            <b-media vertical-align="top" v-if="file_note!==null">
                  <template #aside>
                    <b-img
                      :src="file_note"
                      blank-color="#ccc"
                      width="64"
                      alt="placeholder"
                      
                    />
                  </template>
                  
                  <b-card-text class="mb-0">
                
                    <b-button
                    size="sm"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-warning"
                      class="btn-icon"
                      @click="editPhotoNote()"
                    >
                      <feather-icon icon="EditIcon" />
                    </b-button>
                  </b-card-text>
                </b-media>
            <b-form-file v-else
            required
                v-model="file_note"
                :state="Boolean(file_note)"
                placeholder="Choisissez ou faites glisser un fichier..."
                drop-placeholder="Déposer ici ..."
                @change="fileAdded($event)"
            />
            
            </b-form-group>
            <br /><br />
          <b-button variant="primary" @click="saveNote()">Save note</b-button>
        </div>
      </b-card>
        <b-card v-if="(user && user.is_special_user==true) || $isFactory"  class="border">
          <div class="title-card">
           
            <span>Change order status</span>
          </div>
          <br />
          <b-form-select v-model="statusSelected" :options=" $isFactory ? statusOptionsFactory : statusOptions"></b-form-select>
          <br /><br />
          <b-button variant="primary" @click="changeStatus()">Change status</b-button>

          
        </b-card>
        <b-card v-if="(user && user.is_special_user==true) || $isFactory"  class="border">
          <div class="title-card">
            <img src="@/assets/images/delivery.svg" />
            <span>Delivery</span>
          </div>
          <br />
          Carrier:<br />
          <b-form-select
                v-model="delivery_carrier"
                :options="carrierOptions"
                :state="error_carrier ? false : null"
              />
            <br /><br />
            <b-button @click="updateCarrier()" variant="primary">Save carrier</b-button>
            <br />
            <br />
            Tracking number :<br />
            <b-form-input
              id="basicInput"
              v-model="trackingNumber"
           
            :state="error_tracking_number ? false : null"
            />
            <br />
            <b-button @click="updateTracking()" variant="primary">Save tracking number</b-button>
        </b-card>
        
      
      <b-row v-else class="mb-2">

        <div v-if="($user.id==1336 || $user.id==1369 || $user.id==1451 || $isAdmin || $user.id==690) && order.status!='ready_to_print'">
          <b-button class='mr-1' variant="secondary" @click="markReady()">Mark as ready to print</b-button>
        </div>

        <div v-if="displayStatusSelection==false && order.status!='printing'  && order.status!='canceled'">
         
          <b-button  variant="danger" @click="displayStatusSelection=true">Cancel order</b-button>
        </div>
        <div v-else-if="displayStatusSelection==true">
      
          <b-button variant="danger"  @click="updateStatus()">Confirm cancel</b-button>  <b-button variant="primary"  @click="displayStatusSelection=false">Cancel</b-button>
        </div>
      </b-row>
      
      
      
      <b-card class="border" v-if="order.address">
        <div class="header-card">
          <div class="title-card">
            <img src="@/assets/images/location.svg" />
            <span>Client informations</span>
          </div>
          <b-button class="edit-btn" v-b-modal.modal-edit-informations v-if="(user && user.is_special_user==true) || $isFactory" variant="primary"><img src="@/assets/images/edition.svg" /> Edit informations</b-button>
        </div>
        <br />
        <template v-if="order.address.first_name && order.address.last_name">
          {{ order.address.first_name }} {{ order.address.last_name }}<br />
        </template>
        <template v-else>
        {{ order.user.name }} {{ order.user.surname }}<br />
        </template>
        <span class="address-content">
          <template v-if="order.address.email">
            Email: {{ order.address.email }}<br />
          </template>
          Phone:{{order.address.phone}}<br />
          {{order.address.address1}} - {{order.address.address2}}<br />
          {{order.address.city}} {{order.address.postcode}}<br />
          {{order.address.country}}
        </span>

        
      </b-card>
    </b-card>
  </b-row>

 

</div>
<b-modal id="modal-edit-informations"  size="lg"
   ok-title="Save"
  cancel-title="Close"
  title="Edit informations"
  @ok="updateAddress"
      > 

      <b-row>
        <b-col md="6">
          <b-form-group label="First name">
            <b-form-input v-model="addressForm.first_name" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Last name">
            <b-form-input v-model="addressForm.last_name" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group label="Email">
            <b-form-input v-model="addressForm.email" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Phone">
            <b-form-input v-model="addressForm.phone" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="12">
          <b-form-group label="Address 1">
            <b-form-input v-model="addressForm.address1" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
       
        <b-col md="6">
          <b-form-group label="Address 2">
            <b-form-input v-model="addressForm.address2" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="City">
            <b-form-input v-model="addressForm.city" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        
        <b-col md="6">
          <b-form-group label="Postcode">
            <b-form-input v-model="addressForm.postcode" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Country">
            <b-form-input v-model="addressForm.country" />
          </b-form-group>
        </b-col>
      </b-row>
      
</b-modal>
</b-overlay>
</template>

<script>
import {BModal, BButton,BOverlay, BImg, VBModal, BMedia, BFormFile, BCol, BRow, BFormTextarea, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest, Woocommerce,Auth} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ScanPopup from '../../components/ScanPopup.vue'
import PrescriptionPopup from '../../components/PrescriptionPopup.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import emitter from 'tiny-emitter/instance'
import Vue from 'vue'
import CartImage from "./CartImageComponent.vue";
import { saveAs } from 'file-saver';
import AdjustmentReport from '../order-review/AdjustmentReport.vue'
import Ripple from 'vue-ripple-directive'
import OrderItemsContent from './OrderItemsContent.vue'
export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BOverlay,
    BBadge,
    BPagination,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BFormSelect,
    BImg,
    BDropdown,
    BDropdownItem,
    CartImage,
    BModal,
    BButton,
    BRow,
    BCol,
    BFormFile,
    BMedia,
    ScanPopup,
    PrescriptionPopup,
    AdjustmentReport,
    OrderItemsContent
  },
  data() {
    return {
      order:null,
      displayStatusSelection:false,
      statusSelected:null,
      delivery_carrier:null,
      trackingNumber:null,
      error_carrier:false,
      error_tracking_number:false,
      file_note:null,
      cart_items:null,
      addressForm:{
        first_name:'',
        last_name:'',
        email:'',
        phone:'',
        address1:'',
        address2:'',
        city:'',
        postcode:'',
        country:'',
        pupillary_height:null,
        left_pupillary_height:null,
        right_pupillary_height:null,
        pupillary_distance:null,
        left_pupillary_distance:null,
        right_pupillary_distance:null,
      },
      statusOptions:[{value:'completed',text:'Received'},{value:'confirmed',text:'Confirmed'},{value:'in production',text:'In production'},{value:'verified',text:'Verified'},{value:'shipped',text:'Shipped'},{value:'delivered',text:'Delivered'},{value:'canceled',text:'Canceled'},{value:'returned',text:'Returned'}],
      statusOptionsFactory:[{value:'in production',text:'In production'},{value:'verified',text:'Verified'},{value:'shipped',text:'Shipped'},{value:'delivered',text:'Delivered'}],
      pageLength: 10,
      carrierOptions:['DHL','COLISSIMO','CHRONOPOST','FEDEX'],
      dir: false,
      fitting_result_custom_fit:[],
      photos:null,
      currentScan:null,
      currentPrescription:null,
      displayPrescriptionPopup:false,
      displayScanPopup:false,
      loading:true,
      trackingNumber:'',
      user:null,
      fitting_results:[],
      pupillaryHeight:[],
      eyeToLensDistance:[],
    }
  },
  directives: {
    Ripple,
  },
  methods:{
    goBackToOrders() {
      const page = Number(this.$route.query.page)
      this.$router.push({
        name: 'orders',
        query: page > 1 ? { page } : {},
      })
    },
    editPhotoNote() {
      this.file_note=null
    },
    fileAdded(event)
    {
      var reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = () => {
        
          let b64=reader.result.split(';')
          let type=b64[0]
          if(type.includes('image'))
          {
              let base64=b64[1]
              //base64.replace('base64,','')
              this.currentBase64=reader.result
              this.file_note=this.currentBase64
              this.form.photo=this.currentBase64
          }
          else
          {
              this.file_note=null
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "This is not an image !",
                  icon: 'AlertCircleIcon',
                  variant: 'warning',
                },
              })
          }
          
      };
    },
    async updateAddress() {
      this.loading=true
      let datas=this.addressForm
      delete datas.id
      await APIRequest.update('addresses',this.order.address.id,datas)
      await this.getOrder()
      this.loading=false
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'The informations have been updated !',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    },
    calculateOrderItems() {
      let total=0
      for(let i=0;i<this.order.order_items.length;i++) {
        total+=this.order.order_items[i].quantity
      }
      return total
    },
    async updateTracking() {
      this.loading=true
      this.error_tracking_number=false
      if(!this.trackingNumber)
      {
        this.error_tracking_number=true
        this.loading=false
        
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'You must set a tracking number!',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        return
      }
      let datas={tracking_number:this.trackingNumber}
      
      await APIRequest.update('orders',this.order.id,datas)
      await this.getOrder()
      this.loading=false
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'The tracking number has been updated !',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    },
     async updateCarrier() {
      this.loading=true
      this.error_carrier=false
      if(!this.delivery_carrier)
      {
        this.error_carrier=true
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'You must set a carrier!',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        return
      }
      let datas={delivery_carrier:this.delivery_carrier}

      await APIRequest.update('orders',this.order.id,datas)

      await this.getOrder()
      this.loading=false
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'The carrier has been updated !',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
    },

    async changeStatus() {
      this.loading=true
    
      console.log(this.statusSelected)
      if(this.statusSelected != this.order.status)
      {
        if(this.statusSelected == 'shipped' && (!this.order.delivery_carrier || !this.order.tracking_number))

        {
          if(!this.order.delivery_carrier)
          {
            this.error_carrier=true
          }
          if(!this.order.tracking_number)
          {
            this.error_tracking_number=true
          }
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'You must set a carrier and a tracking number to ship the order !',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          this.loading=false
          return
        }
        let datas={status:this.statusSelected}
      
        await APIRequest.update('orders',this.order.id,datas)
        await this.getOrder()
    
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'The status has been updated !',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      }
      else
      {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'The status is already the same !',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
      }
      this.loading=false
        
      
     
    },
    async markReady() {
      this.loading=true
    
     
      
        let datas={status:'ready_to_print'}
      
        await APIRequest.update('orders',this.order.id,datas)
        await this.getOrder()
    
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'The status has been updated !',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      
      this.loading=false
        
      
     
    },
    async updateStatus() {
      this.loading=true
     
      if(this.statusSelected.value != this.order.status)
      {
        let datas={status:'canceled'}
      
        await APIRequest.update('orders',this.order.id,datas)
        await this.getOrder()
        this.loading=false
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'The status has been updated !',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
      }
      else
      {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'The status is already the same !',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
      }
      this.loading=false
      
     
    },
    async saveNote() {
      this.loading=true
      
      let datas={note:this.order.note,photo_note:this.file_note}
      
      
      await APIRequest.update('orders',this.order.id,datas)
      this.loading=false
    },
    displayCanvasModal() {
      this.$bvModal.show("modal-scan-canvas")
    },
    calculatePhotoSimple(photo) {
      return photo.replace('[','').replaceAll("'",'')
    },
    displayScan(id) {
      this.currentScan=id
      this.displayScanPopup=true
    },
    displayPrescription(id) {
      this.currentPrescription=id
      this.displayPrescriptionPopup=true
    },
    async getOrder() {
      let order=await APIRequest.detail('orders',this.$route.params.id)
      this.order={}
      this.order=order
      this.file_note=this.order.photo_note
      this.fitting_results=[]

      this.statusSelected=this.order.status
      this.delivery_carrier=this.order.delivery_carrier
      this.trackingNumber=this.order.tracking_number

      this.addressForm={...this.order.address}

      for(let i=0;i<this.order.order_items.length;i++)
      {
       
        this.order.order_items[i]=await APIRequest.detail('order-items',this.order.order_items[i].id)
      
        if((this.order.order_items[i].glass.frame_drop_available==true || this.order.order_items[i].glass.id==58) && this.order.order_items[i].scan && this.order.order_items[i].size)
        {
          let fitting_results = await APIRequest.list_with_request('fitting-results','?scan='+this.order.order_items[i].scan.id+'&glass='+this.order.order_items[i].glass.id)
          this.fitting_results.push(fitting_results[0])


          if(fitting_results[0][0].final_size=="xs")
          {
            this.pupillaryHeight.push(fitting_results[0][0].pupillary_height_s)
          }
          else if(fitting_results[0][0].final_size=="s")
          {
            this.pupillaryHeight.push(fitting_results[0][0].pupillary_height_s)
          }
          else if(fitting_results[0][0].final_size=="m")
          {
            this.pupillaryHeight.push(fitting_results[0][0].pupillary_height_m)
          }
          else if(fitting_results[0][0].final_size=="l")
          {
            this.pupillaryHeight.push(fitting_results[0][0].pupillary_height_l)
          }
          else if(fitting_results[0][0].final_size=="xl")
          {
            this.pupillaryHeight.push(fitting_results[0][0].pupillary_height_xl)
          }
          
          if(fitting_results[0][0].final_size=="xs")
          {
            this.eyeToLensDistance.push(fitting_results[0][0].eye_to_lens_distance_xs)
          }
          else if(fitting_results[0][0].final_size=="s")
          {
            this.eyeToLensDistance.push(fitting_results[0][0].eye_to_lens_distance_s)
          }
          else if(fitting_results[0][0].final_size=="m")
          {
            this.eyeToLensDistance.push(fitting_results[0][0].eye_to_lens_distance_m)
          }
          else if(fitting_results[0][0].final_size=="l")
          {
            this.eyeToLensDistance.push(fitting_results[0][0].eye_to_lens_distance_l)
          }
          else if(fitting_results[0][0].final_size=="xl")
          {
            this.eyeToLensDistance.push(fitting_results[0][0].eye_to_lens_distance_xl)
          }

        }
        else
        {
          this.pupillaryHeight.push(null)
          this.eyeToLensDistance.push(null)
        }
        
        if(this.order.order_items[i].scan && !this.order.order_items[i].size && (this.order.user.id==1336 || this.order.user.id==1369 || this.order.user.id==1451))
        {
          let fitting_results = await APIRequest.list_with_request('fitting-results-custom-fit','?scan='+this.order.order_items[i].scan.id+'&glass='+this.order.order_items[i].glass.id+"&status=success")
          this.fitting_result_custom_fit=fitting_results[0]
        }
        else
        {
          this.fitting_result_custom_fit.push(null)
        }
      }



      let cart_items_new=[]
        for(let i=0;i<this.order.order_items.length;i++) {
        let item = await APIRequest.detail('order-items',this.order.order_items[i].id) 
        cart_items_new.push(item)
      }

      this.cart_items=cart_items_new

      if(!this.order.user)
      {
        this.order.user={}
        this.order.user.name=''
        this.order.user.surname='Inconnu'
      }
      
      if(!this.order.user)
      {
        this.order.user={}
        this.order.user.name=''
        this.order.user.surname='Inconnu'
      }
      this.photos=[]
    
    },
    parseJwt (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    },
    
  },
  watch:{
    
  },
  async mounted()
  {
    this.loading=true
    if(this.$route.params.token)
    {
      localStorage.token_senseye_auth=this.$route.params.token
      const jwtUser=this.parseJwt(this.$route.params.token)
      const user_data=await Auth.get_user(jwtUser.username)
      this.user=user_data
      localStorage.id_user_senseye_auth=user_data.id
      Vue.prototype.$user=user_data
      Vue.prototype.$isAdmin = !!(user_data.roles && user_data.roles.includes('ROLE_ADMIN'))
      Vue.prototype.$isFactory = !!(user_data.roles && user_data.roles.includes('ROLE_FACTORY'))
    }
    else if(localStorage.id_user_senseye_auth)
    {
      this.user=await Auth.get_user_with_id(localStorage.id_user_senseye_auth)
    }
    else
    {
      this.user=this.$user
    }
    
    emitter.on('hide-popup-scan', function () {
      this.displayScanPopup=false
    }, this);
    emitter.on('hide-popup-prescription', function () {
      this.displayPrescriptionPopup=false
    }, this);
    await this.getOrder()
    this.loading=false
  }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';



.item-left
{
  display: flex;
  justify-content:flex-start;

  align-items: center;
  gap:15px;
 
}
.download-item:last-child
{
  border-bottom:none;
}
.download-item
{
  padding-left:20px;
  padding-right:20px;
  display: flex;
  justify-content: space-between;
  padding-top:15px;
  padding-bottom:15px;
  align-items: center;
  border-bottom:1px solid #f1f1f1;
}
.image-dl img 
{
  width:100%;
}
.image-dl
{
  width:72px;
}
.address-content
{
  color:#999;
}
.edit-btn
{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap:5px;
  img {
    top:0;
    width:15px;
    filter: brightness(100) invert(1);
  }
}
.totals
{
  margin-top:20px;
  padding-top:20px;
  border-top:1px solid #f1f1f1;
  margin-bottom:40px;
  display:flex;
  justify-content: space-between;
  align-items: center;
  width:100%;
  
  color:#999;
}
.note-form input,
.note-form textarea
{
  background:#f1f1f1;
  border:none;
  resize: none;
}
.status-item
{
  display:flex;
  justify-content: flex-start;
  align-items:  center;
  gap:10px;
}
.back-button
{
  background-color:#fff !important;
  border-radius: 5px;
  width:42px;
  height: 42px;
  display: flex;
  padding:0 !important;
  
  z-index:9;
  justify-content: center;
  align-items: center;
  img 
  {
    transform: rotate(180deg);
  }
 
}
.status-content
{
  display:flex;
  justify-content: space-between;
  align-items: center;
  gap:10px;width:100%;
  padding-left:10px;
}
.status-separator
{
  height:1px;
  flex:1;
  background:#999;
}
.product-details
{
  color:#999;
}
.order-item-content
{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap:20px;
}
.order-item
{
  margin-top:20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap:20px;
}
.product-details .product-name
{
  
  color:#000;
}
.order-status
{
  position:absolute;
  top:20px;
  right:20px;
}
.product-image
{
  border-radius:5px;
  background:#f1f1f1;
 width:110px; 
}
.order-info .legend
{
color:#999;
}
.order-infos
{
  margin-top:20px;
  padding-top:20px;
  border-top:1px solid #f1f1f1;
  width:100%;
  border-bottom:1px solid #f1f1f1;
  padding-bottom:20px;
  display:flex;
  justify-content: flex-start;
  align-items: center;
  gap:20px;
}
.note-form-button
{
  margin-top:15px;
  display:flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex:1;
  gap:12px;
}

</style>
